export default "__VITE_ASSET__590cb880__"